/* 布局 */
//前台
import Layout from "@views/layout";

const daystatisticsRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
            {
            path: "daystatistics",
            name: "DAYSTATISTICS",
            meta: {
                title: "每日数据统计",
                sort: 1,
            },
            component: () => import("@views/business/daystatistics/index.vue"),
            redirect: {
                name: "DAYSTATISTICS_LIST",
            },
            children: [
                {
                    path: "list",
                    name: "DAYSTATISTICS_LIST",
                    meta: {
                        title: "每日数据统计",
                        sort: 2,
                        keepAlive:true
                    },
                    component: () => import("@views/business/daystatistics/list.vue"),
                },
                                                        ],
    },


        ],
};

export default daystatisticsRouter;
